<template>
  <div :class="label ? 'd-flex align-center all-width w-100' : 'd-inline-block'" data-testid="activity-log-modal">
    <!-- Trigger icon button -->
    <v-tooltip bottom content-class="tooltip-bottom" :disabled="!!label">
    <template v-slot:activator="{ on, attrs }">
      <div class="d-flex align-center cursor-pointer flex-grow-1" style="width: 100%;" v-bind="attrs" v-on="on" @click.stop="openDialog">
        <!-- List item mode: plain v-icon matching other menu items -->
        <v-icon v-if="listItemMode" class="pr-2">mdi-history</v-icon>
        <v-btn icon v-else-if="useMdiHistory"><v-icon class="">mdi-history</v-icon></v-btn>
        <base-button
          v-else
          icon-style
          small
          image="/img/icons/ActivityLogNew.svg"
          image-alt="Activity Log Icon"
          data-testid="activity-log-modal__open-btn"
          :class="label ? 'mr-2' : ''"
        />
        <span v-if="label">{{ label }}</span>
      </div>
    </template>
    <span>Activity Log</span>
</v-tooltip>

    <!-- Dialog -->
    <v-dialog
      v-model="dialog"
      max-width="560"
      content-class="activity-log-modal"
      data-testid="activity-log-modal__dialog"
    >
      <v-card class="d-flex flex-column activity-log-modal__card" data-testid="activity-log-modal__card">
      <!-- Header -->
      <div class="activity-log-modal__header" data-testid="activity-log-modal__header">
        <span class="activity-log-modal__header-title">Activity Log</span>
        <v-btn icon small dark @click="close" data-testid="activity-log-modal__close-btn">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- Scrollable content -->
      <div class="activity-log-modal__content" data-testid="activity-log-modal__content">
        <!-- Sticky sub-header: description + filter -->
        <div class="activity-log-modal__subheader" data-testid="activity-log-modal__subheader">
          <span 
            class="font-weight-medium"
            :title="rowDescription"
            data-testid="activity-log-modal__description"
          >
            {{ rowDescription || '—' }}
          </span>

          <!-- Filter -->
          <!-- <div
            v-click-outside="closeFilter"
            class="activity-log-modal__filter-wrap"
            data-testid="activity-log-modal__filter-wrap"
          >
            <button
              :class="[
                'activity-log-modal__filter-btn',
                { 'activity-log-modal__filter-btn--active': filterOpen }
              ]"
              @click="filterOpen = !filterOpen"
              data-testid="activity-log-modal__filter-btn"
            >
              <v-icon x-small :color="filterOpen ? 'white' : ''">mdi-tune-variant</v-icon>
              Filter
              <span
                v-if="selectedAction !== 'All'"
                class="activity-log-modal__filter-badge"
                data-testid="activity-log-modal__filter-badge"
              >1</span>
            </button> -->

            <!-- Dropdown -->
            <!-- <div
              v-if="filterOpen"
              class="activity-log-modal__filter-dropdown"
              data-testid="activity-log-modal__filter-dropdown"
            >
              <div class="activity-log-modal__filter-header">
                <p class="activity-log-modal__filter-label">Filter by Action</p>
                <button
                  v-if="selectedAction !== 'All'"
                  class="activity-log-modal__filter-clear"
                  @click="selectFilter('All')"
                  data-testid="activity-log-modal__filter-clear-btn"
                >Clear All</button>
              </div>
              <button
                v-for="actionType in actionTypes"
                :key="actionType.key"
                :class="[
                  'activity-log-modal__filter-option',
                  { 'activity-log-modal__filter-option--selected': selectedAction === actionType.key }
                ]"
                @click="selectFilter(actionType.key)"
                :data-testid="'activity-log-modal__filter-option-' + actionType.key"
              >
                {{ actionType.label }}
                <v-icon
                  v-if="selectedAction === actionType.key"
                  x-small
                  color="primary"
                >mdi-check</v-icon>
              </button>
            </div> -->
          <!-- </div> -->
        </div>

        <!-- Timeline list -->
        <div class="activity-log-modal__timeline" data-testid="activity-log-modal__timeline">
          <!-- Loading state -->
          <div v-if="loading" class="text-center pa-8">
            <v-progress-circular indeterminate color="primary" size="32" />
          </div>

          <!-- Empty state -->
          <p
            v-else-if="filteredData.length === 0"
            class="activity-log-modal__empty"
            data-testid="activity-log-modal__empty"
          >
            No entries match this filter.
          </p>

          <!-- Entries -->
          <div
            v-else
            v-for="(entry, index) in filteredData"
            :key="index"
            class="activity-log-modal__entry"
            data-testid="activity-log-modal__entry"
          >
            <!-- Left: Time & Date -->
            <div class="activity-log-modal__entry-time">
              <span class="activity-log-modal__time-text">{{ entry.time }}</span>
              <span class="activity-log-modal__date-text">{{ entry.date }}</span>
            </div>

            <!-- Center: Timeline dot + lines -->
            <div class="activity-log-modal__entry-line">
              <div
                :class="[
                  'activity-log-modal__line-top',
                  { 'activity-log-modal__line-top--visible': index !== 0 }
                ]"
              />
              <div class="activity-log-modal__dot" />
              <div
                :class="[
                  'activity-log-modal__line-bottom',
                  { 'activity-log-modal__line-bottom--visible': index !== filteredData.length - 1 }
                ]"
              />
            </div>

            <!-- Right: Content -->
            <div class="activity-log-modal__entry-content ">
              <p class="activity-log-modal__action-text">{{ entry.action }}</p>
              <div class="activity-log-modal__user-row">
                <v-tooltip bottom content-class="tooltip-bottom">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="activity-log-modal__avatar" v-bind="attrs" v-on="on">
                      {{ entry.avatarLetter }}
                    </div>
                  </template>
                  <span>{{ entry.role }}</span>
                </v-tooltip>
                <div class="activity-log-modal__user-info">
                  <!-- <span class="activity-log-modal__user-name">{{ entry.role }}</span> -->
                  <span class="activity-log-modal__user-email">{{ entry.email }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ActivityLog',

  props: {
    label: { type: String, default: '' },
    useMdiHistory: { type: Boolean, default: true },
    /** Renders plain v-icon matching v-list-item menu patterns */
    listItemMode: { type: Boolean, default: false },
    rowDescription: { type: String, default: '' },
    /** Resource ID used to build the activity log API endpoint internally. */
    resourceId: { type: String, default: '' },
    /**
     * Config map that translates the API response `type` field to a display
     * text, e.g. { projectopen: { displaytext: 'Project Opened' }, … }
     */
    config: { type: Object, default: () => ({}) },
    type: { type: Array, default: () => [] },
  },

  data() {
    return {
      dialog: false,
      selectedAction: 'All',
      filterOpen: false,
      loading: false,
      loglist: [],
      uniqueTypes: [],
    };
  },

  computed: {

    /**
     * Transform raw API entries into the timeline display format.
     * Each raw entry has: type, text, created_at, userid_detail { name, email }
     */
    activitylogdata() {
      return this.loglist.map((log) => {
        const configEntry = this.config[log.type] || {};
        const actionLabel = log.text || configEntry.displaytext || log.type;
        const user = log.userid_detail || {};
        const userName = user.name || '';
        const userEmail = user.contactemail || '';
        const dt = new Date(log.created_at);

        return {
          type: log.type,
          time: this.$nova.formatDateTime
            ? this.$nova.formatDateTime(dt, 'hh:mm A')
            : dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
          date: this.$nova.formatDateTime
            ? this.$nova.formatDateTime(dt, 'DD MMM YYYY')
            : dt.toLocaleDateString([], { day: '2-digit', month: 'short', year: 'numeric' }),
          action: actionLabel,
          role: userName,
          avatarLetter: userName ? userName.charAt(0).toUpperCase() : '?',
          email: userEmail,
        };
      });
    },

    /** Build unique action types from the API unique_type list for the filter dropdown. */
    actionTypes() {
      const types = this.uniqueTypes.map((type) => {
        const configEntry = this.config[type] || {};
        return { key: type, label: configEntry.displaytext || type };
      });
      return [{ key: 'All', label: 'All' }, ...types];
    },

    /** Filtered entries based on the selected action type filter. */
    filteredData() {
      if (this.selectedAction === 'All') return this.activitylogdata;
      return this.activitylogdata.filter((e) => e.type === this.selectedAction);
    },
  },

  methods: {
    /** Open dialog and fetch data. */
    openDialog() {
      this.dialog = true;
      this.loadData();
    },

    close() {
      this.dialog = false;
    },

    closeFilter() {
      this.filterOpen = false;
    },

    selectFilter(type) {
      this.selectedAction = type;
    },

    /** Fetch activity log entries via Vuex store action. */
    async loadData() {
      if (!this.resourceId) return;
      this.loading = true;
      this.loglist = [];
      this.selectedAction = 'All';
      try {
        const result = await this.$store.dispatch('fetchActivityLog', {
          resourceId: this.resourceId,
          type: this.type,
        });
        this.loglist = result.data;
        this.uniqueTypes = result.unique_type;
      } catch {
        // Error already handled by the store action
      } finally {
        this.loading = false;
      }
    },
  },

  beforeDestroy() {
    this.dialog = false;
    this.selectedAction = 'All';
    this.filterOpen = false;
    this.loglist = [];
    this.uniqueTypes = [];
  },
};
</script>

<style lang="scss" scoped>
@import './ActivityLog.scss';
</style>
